import { environment } from "src/environments/environment";

export class QueryConstants {
  public static base_Url = environment["nextGenQueryAPIURL"] + "query-apbuilder/";
  public static account_base_Url = environment["nextGenAccountsAPIURL"];

  // Query Builder Api URL
  public static keywords_Url = QueryConstants.base_Url + "GetQueryKeywords";
  public static getUsers_Url = QueryConstants.base_Url + "GetUsers";
  public static category_Url = QueryConstants.base_Url + "GetQueryCategory";
  public static getQuery_Url = QueryConstants.base_Url + "GetQueries";
  public static getTable_Url = QueryConstants.base_Url + "GetMostUsedTables";
  public static getFilteredTable_Url = QueryConstants.base_Url + "getalltables";
  public static get_primary_key_url =
    QueryConstants.base_Url + "GetPrimaryKeyData";
  public static get_columns_data_object_url =
    QueryConstants.base_Url + "GetColumnsDataObject";
  public static update_query_table_url =
    QueryConstants.base_Url + "UpdateQueryTable";
  public static get_query_table_url = QueryConstants.base_Url + "GetQueryTable";
  public static get_recent_queries_url =
    QueryConstants.base_Url + "getrecentqueries";
  public static get_checkout_data_url =
    QueryConstants.base_Url + "getcheckoutdata";
  public static checkout_query_data_url =
    QueryConstants.base_Url + "checkoutquery";
  public static checkin_query_data_url =
    QueryConstants.base_Url + "checkinquery";
  public static execute_query_data_url =
    QueryConstants.base_Url + "runquery";
  public static copy_query_data_url = QueryConstants.base_Url + "copyquery";
  public static disable_query_url = QueryConstants.base_Url + "disablequery";
  public static enable_query_url = QueryConstants.base_Url + "enablequery";
  public static get_query_params_url =
    QueryConstants.base_Url + "getqueryparameters";
  public static get_dataset_url = QueryConstants.base_Url + "getdataset";
  public static get_queryloadfordesigner_url =
    QueryConstants.base_Url + "getqueryloadfordesigner";
  public static export_Query = QueryConstants.base_Url + "ExportQuery";
  public static get_joinsForColumns_url = QueryConstants.base_Url + "GetJoinsForColumn";
  public static getTenantInfo_Url = QueryConstants.base_Url + "GetTenantInfo";
  public static getpossibleColumns_Url = QueryConstants.base_Url + "GetPossibleColumns";
  public static getallLists_Url = QueryConstants.base_Url + "GetAllLists";
  public static getallListItem_Url = QueryConstants.base_Url + "GetAllListItems";

  // Accounts Api URL
  public static getUsers_image_Url =
    QueryConstants.account_base_Url + "user/getprofilephoto/";

  // Const table action button
  public static save_query = QueryConstants.base_Url + "SaveQuery";
  public static editActionTitle = "Edit Query";
  public static deleteActionTitle = "Delete";
  public static disableActionTitle = "Disable Query";
  public static enableActionTitle = "Enable Query";
  public static copyActionTitle = "Copy Query";
  public static runActionTitle = "Run Query";

  // Const Navigations
  public static queryAdd_Navigation = "Query/QueryAdd";
  public static querySearch_Navigation = "Query/QuerySearch";
  public static queryEdit_Navigation = "Query/QueryEdit";
  public static queryManager_Navigation = "Query/QueryManager";
  public static queryRun_Navigation = "Query/QueryRun";

  // Const Success/Error Messages
  public static query_NotFound = "Query not found!"
  public static queryDelete_SuccessMsg = "Query deleted successfully";
  public static queryDelete_ErrorMsg = "Unexpected error. Delete Query Failed.";
  public static templateWarning_Msg =
    "Please select at least one record from results.";
  public static queryAdd_SuccessMsg = "Query created successfully with ID: ";
  public static queryAdd_ErrorMsg =
    "Unexpected error. Create New Query Failed.";
  public static queryTemplateSearchErrorMsg =
    "Unexpected error. Query Template Search Failed.";
  public static queryUpdate_SuccessMsg = "Query updated successfully with ID: ";
  public static queryCopy_SuccessMsg = "Query copied successfully with ID: ";
  public static queryUpdate_ErrorMsg = "Unexpected error. Update Query Failed.";
  public static queryManagerLoad_ErrorMsg =
    "Unexpected error. Query Manager Load Failed.";
  public static queryDisable_SuccessMsg = "Query disabled successfully";
  public static queryDisable_ErrorMsg =
    "Unexpected error. Disable Query Failed.";
  public static queryenable_SuccessMsg = "Query enabled successfully";
  public static queryenable_ErrorMsg = "Unexpected error. Enable Query Failed.";
  public static querySave_SuccessMsg = "Query saved successfully";
  public static querySave_ErrorMsg = "Save Query Failed.";
  public static duplicateQueryParam_ErrorMsg =
    "Query parameter rule already exists. Please change your parameter name to proceed.";
  public static space_ErrorMsg = "Leading and trailing spaces are not allowed.";
  public static marked_Required = "Query Param marked 'Required' successfully";
  public static marked_Not_Required =
    "Query Param marked 'Not Required' successfully";
    public static alias_ErrorMsg = 'Table alias cannot have any spaces or special characters';
    public static keyword_ErrorMsg = 'Keyword cannot have any spaces or special characters';

  // Const value
  public static whiteSpaceRegex = /^(?!.*\s$)(?!^\s).*/;
  public static token_Lifetime = 5;
  public static maxDate = new Date("9999-12-31T23:59:59");
  public static queryNameLength = 50;
  public static queryDescLength = 1000;
  public static tableAliasLength = 50;
  public static queryKeywordLength = 20;
  public static defaultAllowEditId = 1000000000; //CaseWorthy default for AllowEditID
  public static numberRegex = "[0-9/]*";
  public static dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  public static atFrontAndSpaceNotBetweenValidation =
    "^(@[_a-zA-Z])[a-zA-Z0-9_]+$";
  public static datePatternRegex = /^\d{4}-\d{2}-\d{2}T00:00:00$/;
  public static dateTimePatternRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
  public static timeRegex = /^\d{4}[-/]\d{2}[-/]\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/;
  public static moneyTypeRegex = /^\d+(\.\d{1,2})?$/;
  public static tableAliasRegex = "^[a-zA-Z0-9_]*$";
  public static noSpaceInBetween = "^[a-zA-Z0-9_]*$";
  public static readonly ruleSymbols: { [key: number]: string } = {
    1: "==",
    2: ">",
    3: ">=",
    4: "<",
    5: "<=",
    6: "!=",
    7: "IN",
    8: "NOT IN",
    9: "AND",
    10: "OR",
  };

  public static readonly dataType: { [key: number]: string } = {
    1: "bit",
    // 2: "tinyint",
    3: "int",
    4: "varchar(50)",
    5: "varchar(256)",
    6: "varchar(max)",
    // 7: "text",
    8: "nvarchar(50)",
    9: "nvarchar(256)",
    10: "nvarchar(max)",
    // 11: "ntext",
    12: "money",
    // 13: "list",
    14: "datetime",
    15: "date",
    16: "uniqueidentifier",
  };

  public static readonly columnTitle: { [key: string]: string } = {
    "Created Date": "createdDate",
    "Created By": "Author",
    "Query Name": "QueryName",
    "Query ID": "QueryID",
    "Query Category":"QueryCateogryNavigation.CategoryName",
  };
}
export enum QuerySaveType {
  Cancel,
  Save,
  NoSave,
}
export enum QueryCategory {
  Form = 1,
  List = 2,
  Query = 3,
  Sub_Query = 4,
  Temporary_Queries = 5,
  CaseBot_Report = 6,
  Configurable_Alerts_Content = 7,
  Configurable_Alerts_Recipients = 8,
  QueryTemplates = 9,
}
export enum QueryRules {
  Columns = 1,
  literalValue = 2,
  rightLiteralValue = 2,
  Parameters = 4,
  subquery = 6,
  splitsubquery = 7,
  formula = 8,
  rightformula = 8,
  rightColumns = 1,
  rightParameters = 4,
  combineRuleType = 5
}

export type DatasetSortingOrderType = '~PRIMARYAZ~' | '~PRIMARYZA~' | '~SECONDARYAZ~' | '~SECONDARYZA~' | '~NOSORT~';
export const summarizationDict = [
  { label: "NO SUMMARIZATION", value: "1" },
  { label: "SUM", value: "2" },
  { label: "COUNT", value: "3" },
  { label: "DISTINCT COUNT", value: "4" },
  { label: "AVG", value: "5" },
  { label: "STD DEV", value: "6" },
  { label: "MIN", value: "7" },
  { label: "MAX", value: "8" },
]